import React, { useContext, useState, useEffect } from "react";
import styles from "./css/contact.module.css";
import { IdiomaContext } from './context/IdiomaContext';
import { traducciones } from '../data/contactData';
import preguntas from '../data/preguntas.json';
// import emailjs from 'emailjs-com';

function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { idioma } = useContext(IdiomaContext);
  const traduccion = traducciones[idioma];
  const [respuestaCorrecta, setRespuestaCorrecta] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [preguntaActual, setPreguntaActual] = useState({});
  const [mensajeExito, setMensajeExito] = useState(""); 
  const [mensajeError, setMensajeError] = useState(""); 

  useEffect(() => {
    const preguntasEnIdioma = preguntas[idioma];
    const preguntaAleatoria = preguntasEnIdioma[Math.floor(Math.random() * preguntasEnIdioma.length)];
    setPreguntaActual(preguntaAleatoria);
  }, [idioma]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setMensajeExito(""); 
    setMensajeError(""); 
    setIsValid(true);

    if (respuestaCorrecta.toLowerCase() === preguntaActual.respuesta.toLowerCase()) {
      const formData = new FormData(e.target);
      fetch('/send/sendmail.php', {  // Cambia esta ruta a la ubicación de tu archivo PHP
        method: 'POST',
        body: formData,
      })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.success) {
          setMensajeExito(traduccion.mensajeExito);
          e.target.reset();
        } else {
          setMensajeError(data.error || traduccion.mensajeError);
        }
      })
      .catch((error) => {
        setMensajeError(traduccion.mensajeError);
      });
    } else {
      setIsValid(false);
    }
  };

  return (
    
    <div className={styles.container}>
      <div className={styles.layout}>
        {/* <button className={styles.closeButton} onClick={() => window.history.back()}>X</button> */}
        <h1 className={styles.layout__title}>{traduccion.Title}</h1>
        
        {!mensajeExito ? (
          <form className={styles.form} onSubmit={handleSubmit}>
            <label htmlFor="name" className={styles.form__label}>{traduccion.formName}</label>
            <input type="text" id="name" name="name" className={styles.form__input} required />
            
            <label htmlFor="email" className={styles.form__label}>{traduccion.formEmail}</label>
            <input type="email" id="email" name="email" className={styles.form__input} required />

            <label htmlFor="subject" className={styles.form__label}>{traduccion.formSubject}</label>
            <input type="text" id="subject" name="subject" className={styles.form__input} required />

            <label htmlFor="message" className={styles.form__label}>{traduccion.formMessage}</label>
            <textarea id="message" name="message" className={styles.form__textarea} required></textarea>
            
            <label htmlFor="question" className={styles.form__label}>{preguntaActual.pregunta}</label>
            <input 
              type="text" 
              id="question" 
              name="question" 
              className={styles.form__input} 
              required 
              onChange={(e) => setRespuestaCorrecta(e.target.value)}
            />
            
            <button type="submit" className={styles.form__submit}>{traduccion.formSubmit}</button>
            {!isValid && <p className={styles.error}>{traduccion.errorRespuesta}</p>}
          </form>
        ) : (
          <p className={styles.successMessage}>{mensajeExito}</p>
        )}
        
        {mensajeError && <p className={styles.errorMessage}>{mensajeError}</p>}
      </div>
    </div>
  );
}

export default ContactPage;
